<tt-modal v-if="isOpen"
          ref="modal"
          class="tt-w-submission-modal"
          :ariaLabel="$msg('submission.title')"
          :closeLabel="$msg('submission.close')"
          :isLoading="!isFormLoaded"
          :popoverMessage="popoverMessage"
          :popoverType="popoverType"
          :notifyOutsideClick="true"
          @showError="onShowError"
          @close="closeSubmissionModal"
          @closePopover="closePopover"
          @outsideClick="outsideClick">
  <tt-submission-mediator v-show="isFormLoaded" 
                          @pageLoading="pageLoading"
                          @pageLoaded="pageLoaded"
                          @showPopoverMessage="onShowPopoverMessage"
                          @showError="onShowError"></tt-submission-mediator>
  <tt-warn-close-modal v-if="isConfirmOpen"
                       @close="closeConfirm"
                       @closeParentModal="closeSubmissionModal"></tt-warn-close-modal>
  <template v-slot:poweredByText>
    <p v-html="poweredByText"></p>
  </template>
</tt-modal>
